import React from 'react';

const Notifications: React.FC = () => {
  return (
    <h1>Notifications</h1>
  )
}

export default Notifications;